<template>
  <div>
    <el-button type="primary" @click="showUser">选择学员</el-button>
    <el-dialog title="选择学员" :visible.sync="dialogVisible" width="30%" :append-to-body="true" @opened="openMonted">
      <el-input suffix-icon="el-icon-search" v-model="formInline.keyword" placeholder="输入学员名称查询"
        style="width: 200px;margin: 10px 0;float: right;" clearable>
      </el-input>
      <el-table :data="userTable.rows" style="width: 100%" @select-all="selectAllUser" @select="selectUser"
        ref="multipleTable" row-key="id" @selection-change="selectChangeUser">
        <el-table-column type="selection" width="55" :reserve-selection="true">
        </el-table-column>
        <el-table-column :prop="itype==2?'appyusername':'realName'" label="学员姓名" width="180">
        </el-table-column>
        <el-table-column prop="stuid" label="学员ID" width="180">
        </el-table-column>
        <el-table-column prop="loginName" label="联系方式">
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;width: 100%;height: 40px;">
        <el-pagination small layout="prev, pager, next" :total="userTable.total" style="float: right;"
          :hide-on-single-page="true" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="formInline.page">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'UserBtn',
    props: ['selectUserIds', 'selectCurseList', 'itype', 'tableUserList', 'orgId'],
    data() {
      return {
        userTable: {
          rows: [],
          total: 0
        },
        dialogVisible: false,
        formInline: {
          rows: 10,
          page: 1,
          keyword: ''
        },
        selectIdArr: [],
        selectUserRows: []
      }
    },
    methods: {
      getUserList: function(flag) {
        var $this = this;
        var orgId = this.orgId ? this.orgId[this.orgId.length - 1] : '';
        // 购买课程
        if (this.itype == '2') {
          this.userTable = {
            rows: this.tableUserList,
            total: this.tableUserList.length
          }
          return;
        };
        if (!flag && this.userTable.rows.length > 0) {
          return;
        };
        
        this.formInline.orgId = orgId;
        
        this.$axios.get('/system/user_role/COM_USER_AQKT/list.htm?' + this.$qs.stringify(this.formInline), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.userTable = data;
        });
      },
      selectAllUser: function(selection, row) {
        var selectIdArr = [];
        var selectUserRows = [];
        selection.map((item) => {
          selectIdArr.push(item.id);
          selectUserRows.push(item);
        })
        this.selectIdArr = selectIdArr;
        this.selectUserRows = selectUserRows;
      },
      selectUser: function(selection, row) {
        var selectIdArr = [];
        var selectUserRows = [];
        selection.map((item) => {
          selectIdArr.push(item.id);
          selectUserRows.push(item);
        })
        this.selectIdArr = selectIdArr;
        this.selectUserRows = selectUserRows;

      },
      selectChangeUser: function(selection) {},
      showUser: function() {
        if (this.selectCurseList.length > 0) {
          this.dialogVisible = true;
          this.getUserList();
        } else {
          this.$message({
            message: '请先选择课程',
            type: 'warning',
            offset: 300
          });
        };
      },
      openMonted: function() {
        if (this.selectUserIds.length > 0) {
          this.userTable.rows.forEach(row => {
            if (this.selectUserIds.indexOf(row.id) >= 0) {
              this.$refs.multipleTable.toggleRowSelection(row, true);
            } else {
              this.$refs.multipleTable.toggleRowSelection(row, false);
            }
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleAave: function() {
        this.$emit('changeUser', this.selectIdArr, this.selectUserRows);
        this.dialogVisible = false
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
    },
    created: function() {},
    mounted: function() {

    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getUserList(1)
        },
        deep: true //true 深度监听
      },
      itype: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getUserList();
        },
        deep: true //true 深度监听
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/UserBtn.vue